import { authAxios } from "./axiosClient";
import { DetailDescription, LogsDescriptionDay } from "../constants";


export const GetDataDetailDescription = (params = {}) => {
  const url = DetailDescription;
  return authAxios().get(url, { params });
};

export const UpdateMonthDetailDescription = (params = {}) => {
  const url = DetailDescription;
  return authAxios().post(url, params);
};

export const getLogsDescriptionDay = (params = {}) => {
  const url = LogsDescriptionDay;
  return authAxios().get(url, { params });
};